<!--卡变更日志-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="会员卡号:">
                <el-input v-model="queryParam.userPhone" placeholder="输入卡号" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="会员姓名:">
                <el-input v-model="queryParam.childName" placeholder="输入会员姓名" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="会员小名:">
                <el-input v-model="queryParam.childPetName" placeholder="输入小名" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="撤销日期:">
                <el-date-picker style="width: 200px;"
                  v-model="queryParam.revokeTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="消费日期:">
                <el-date-picker
                  v-model="queryParam.consumeDay"
                  type="daterange"
                  range-separator=""
                  start-placeholder="开始"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="460"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="userPhone" label="卡号" ></el-table-column>
        <el-table-column prop="cardName" label="卡类型" ></el-table-column>
        <el-table-column prop="childName" label="姓名" ></el-table-column>
        <el-table-column prop="childPetName" label="小名" ></el-table-column>
        <el-table-column prop="payConsume" label="消费金额" ></el-table-column>
        <el-table-column prop="singInTime" label="消费时间" ></el-table-column>
        <el-table-column prop="revokeTime" label="撤销时间" ></el-table-column>
        <!--<el-table-column prop="usedTimes" label="已使用卡次" ></el-table-column>-->
        <!--<el-table-column prop="reduceCount" label="单次扣除卡次" ></el-table-column>-->
        <el-table-column prop="reduceType" label="类型" ></el-table-column>
        <el-table-column prop="produce" label="消费商品" ></el-table-column>
        <!--<el-table-column prop="teacher" label="服务泳师" ></el-table-column>-->
        <!--<el-table-column prop="point" label="满意度" ></el-table-column>-->
        <!--<el-table-column prop="weight" label="体重" ></el-table-column>-->
        <!--<el-table-column prop="circle" label="泳圈型号" ></el-table-column>-->
        <!--<el-table-column prop="swTime" label="游泳时常" ></el-table-column>-->
        <!--<el-table-column prop="test" label="测量" ></el-table-column>-->
        <!--<el-table-column prop="photo" label="拍照" ></el-table-column>-->
        <!--<el-table-column prop="remark" label="备注" ></el-table-column>-->
        <el-table-column prop="revokeReason" label="撤销原因" ></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>

<script>


  import globaldata from "../../../utils/globaldata";
  import {queryCardConsume, queryRevokeCardConsume} from "../../../api/ConsumeRecord";
  import commonUtils from "../../../utils/commonUtils";

  export default {

    data() {
      return {
        listLoading: true,
        queryParam:{
          userPhone: '',
          childName:"",
          childPetName:"",
          teacherName:"",
          storeLessonCardId:0,
          consumeDay:"",
          startDay:"",
          endDay:"",
          revokeTime:'',//撤销日期

          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },

        //表单结果
        tableData: [
        ],




      }
    },
    created(){

      globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);

    },
    mounted() {

    },
    methods: {


      getStoreLessonTemplate(data){
        this.storeLessons =data;
        this.flechList();
      },
      flechList(){
        this.listLoading = true;
        let startDay = null;
        let endDay = null;
        if (commonUtils.isObjectNull(this.queryParam.consumeDay) == false){
           startDay = this.queryParam.consumeDay[0];
          endDay = this.queryParam.consumeDay[1];
        }
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          childPetName:this.queryParam.childPetName ,
          userPhone:this.queryParam.userPhone,
          childName:this.queryParam.childName,
          startDay:startDay,
          endDay:endDay,
          revokeTime:this.queryParam.revokeTime,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        queryRevokeCardConsume(param).then(response =>
        {
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },
      //刷新页面数据
      refreshData(list){

        if (commonUtils.isObjectNull(list)){
          return;
        }

        let tableDataList = [];
        for (let i = 0;i< list.length;++i){


          let data = {

            id: list[i].id,
            storeFrontId: list[i].storeFrontId,
            userBuyCardId: list[i].userBuyCardId,
            childId: list[i].childId,
            userId: list[i].userId,

            storeLessonCardId: list[i].storeLessonCardId,
            lessonTemplateId: list[i].lessonTemplateId,
            lessonName: list[i].lessonName,
            cardName:list[i].cardName,
            userBookLessonId: list[i].userBookLessonId,
            userPhone: list[i].userPhone,
            childName: list[i].childName,
            childPetName: list[i].childPetName,
            childBirthday: list[i].childBirthday,
            payConsume: list[i].payConsume,
            singInTime: list[i].singInTime,
            usedTimes: list[i].usedTimes,
            reduceCount: list[i].reduceCount,
            reduceType: list[i].reduceType,
            produce: list[i].produce,
            revokeTime:list[i].revokeTime,
            revokeReason:list[i].revokeReason,
          };
          tableDataList.push(data);
        }

        this.tableData = tableDataList;
      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.flechList();
      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/consume/reovke-card-consume/index.vue